import React from 'react';
export function OpeningHook() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <p className="text-xl md:text-2xl text-stone-800 mb-8 leading-relaxed font-medium" data-id="element-149">
          Se detiene en la puerta de la cocina y se pregunta: "¿A qué venía
          yo?". O siente ese frío en el pecho cuando el nombre de su nieto no
          sale de su boca, aunque lo tiene "en la punta de la lengua".
        </p>
        <p className="text-lg md:text-xl text-stone-700 leading-relaxed" data-id="element-150">
          No es que su mente se esté apagando. Es que nadie le ha enseñado a
          darle el mantenimiento que su cerebro necesita a los 65+. Usted es la
          guardiana de los recuerdos de su familia, y es hora de asegurar que
          ese tesoro no se pierda.
        </p>
      </div>
    </section>;
}